import {
  UPDATE_CEM_TABLE_LIST,
  UPDATE_CEM_SHIFT_LIST,
  UPDATE_CEM_TEMPLATE_LIST,
  UPDATE_CEM_CHARGE_LIST,
  UPDATE_CEM_SALARY_LIST,
} from './constants'

const initState = {
  tableList: [], // 列表数据
  shiftList: [], // 班次列表
  templateList: [], // 模板列表
  chargeList: [], // 收费类型
  salaryList: [], // 薪酬类型
}

export default function (state = initState, action) {
  switch (action.type) {
    case UPDATE_CEM_TABLE_LIST:
      return Object.assign({}, state, { tableList: action.payload })
    case UPDATE_CEM_SHIFT_LIST:
      return Object.assign({}, state, { shiftList: action.payload })
    case UPDATE_CEM_TEMPLATE_LIST:
      return Object.assign({}, state, { templateList: action.payload })
    case UPDATE_CEM_CHARGE_LIST:
      return Object.assign({}, state, { chargeList: action.payload })
    case UPDATE_CEM_SALARY_LIST:
      return Object.assign({}, state, { salaryList: action.payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubEmployeeManager/reduce.js